module.exports = __webpack_public_path__ + "img/logo.50ac5911.png";